// Event names shared between modules that must not import each other (api.ts and dataCache.js).
export const STAFF_ACCESS_BLOCKED_EVENT = 'floxir:staff-access-blocked';
